/**
 * Resolve a jobs-board URL role slug (e.g. web-developers) to the role display
 * name the collaboration API expects (e.g. Web Developer).
 *
 * Mirrors ProjectsBase.getCurrentSelectedRole matching so SSR loadBriefs and
 * client hydration share the same roles[] / briefs hash.
 *
 * @param {Object<string, Array>|Array<Array>|Array} roleSkills
 *   Category-grouped roleSkills from projects2.filterRoleSkills (API returns a
 *   category→roles object; tests may use an array of groups), or a flat list.
 * @param {string} slugOrName - path :role param or a display name
 * @returns {string|null} role.name when matched, otherwise null
 */
export default function resolveJobsRoleSlug(roleSkills, slugOrName) {
  if (!slugOrName || !roleSkills) {
    return null;
  }

  const needle = String(slugOrName).toLowerCase();
  const groups = normalizeRoleSkillGroups(roleSkills);

  for (let g = 0; g < groups.length; g += 1) {
    const group = groups[g] || [];
    for (let i = 0; i < group.length; i += 1) {
      const roleSkill = group[i];
      if (!roleSkill || !roleSkill.name) {
        continue;
      }
      if (
        (roleSkill.name && roleSkill.name.toLowerCase() === needle) ||
        (roleSkill.name_plural &&
          roleSkill.name_plural.toLowerCase() === needle) ||
        (roleSkill.slug && roleSkill.slug.toLowerCase() === needle) ||
        (roleSkill.slug_plural &&
          roleSkill.slug_plural.toLowerCase() === needle)
      ) {
        return roleSkill.name;
      }
    }
  }

  return null;
}

function normalizeRoleSkillGroups(roleSkills) {
  if (Array.isArray(roleSkills)) {
    if (roleSkills.length === 0) {
      return [];
    }
    // Array of category groups, or a flat list of roles
    return Array.isArray(roleSkills[0]) ? roleSkills : [roleSkills];
  }

  if (typeof roleSkills === 'object') {
    // API shape: { "Graphic Design": [ {...}, ... ], ... }
    return Object.keys(roleSkills).map((key) => roleSkills[key] || []);
  }

  return [];
}
